import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'
import { currencyMap } from 'utils/formatMoney'
import prepareChartData from 'utils/prepareChartData'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import {
  CAMPAIGN_DROP_TABLE_DATA,
  CAMPAIGN_FETCH_CHART_START,
  CAMPAIGN_FETCH_FAIL,
  CAMPAIGN_FETCH_TABLE_START,
  CAMPAIGN_FILTERS_APPLY,
  CAMPAIGN_SET_CHART,
  CAMPAIGN_SET_FILTER,
  CAMPAIGN_SET_TABLE,
  SET_CAMPAIGN_LOGIN,
  SET_CHART_TYPE,
  TOGGLE_METRIC_HIDDEN,
} from 'modules/Statistics/types'

const initialState = {
  login: null,
  table: {
    loadFailed: false,
    loading: false,
    data: [],
    summary: {},
    pagination: {
      total: 0,
    },
  },
  chart: {
    loadFailed: false,
    loading: false,
    data: [],
    summary: {},
    chartType: 'Line',
    measure: {
      impressions: '',
      clicks: '',
      revenue: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
      cost: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
    },
    metrics: [
      { id: 'clicks', isActive: true },
      { id: 'impressions', isActive: true },
      { id: 'cost', isActive: true },
      { id: 'revenue', isActive: true, isHidden: true },
    ],
  },
  filters: null,
}

const setLoading = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: true,
    },
  })

const setStatisticsChart = (state, { payload }) => {
  const { data, summary } = payload

  const preparedChartData = prepareChartData(data, summary)

  return updateObject(state, {
    chart: {
      ...state.chart,
      data: preparedChartData.items,
      summary: preparedChartData.summary,
      loading: false,
      loadFailed: false,
    },
  })
}

const setStatisticsCampaignLogin = (state, { payload }) =>
  updateObject(state, {
    login: payload.login,
  })

const setStatisticsTable = (state, { payload }) =>
  updateObject(state, {
    table: {
      ...state.table,
      ...payload,
      data: [...state.table.data, ...payload.data],
      loading: false,
      loadFailed: false,
    },
  })

const fetchStatisticsFail = (state, { payload }) =>
  updateObject(state, {
    [payload]: {
      ...state[payload],
      loading: false,
      loadFailed: true,
    },
  })

const dropStatisticsTable = (state) =>
  updateObject(state, {
    table: {
      ...initialState.table,
    },
  })

const setStatisticsFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const applyFilters = (state, { payload }) => updateObject(state, { filters: payload })

const toggleMetricHidden = (state, action) =>
  updateObject(state, {
    chart: {
      ...state.chart,
      metrics: [
        ...state.chart.metrics.map((metric) => {
          const { id, isHidden = false } = metric
          if (id === action.payload.id) {
            return { ...metric, isHidden: !isHidden }
          }
          return metric
        }),
      ],
    },
  })

const setChartType = (state, { payload }) =>
  updateObject(state, {
    chart: { ...state.chart, chartType: payload.type },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CAMPAIGN_FILTERS_APPLY:
      return applyFilters(state, action)
    case CAMPAIGN_SET_FILTER:
      return setStatisticsFilters(state, action)
    case CAMPAIGN_SET_CHART:
      return setStatisticsChart(state, action)
    case CAMPAIGN_SET_TABLE:
      return setStatisticsTable(state, action)
    case CAMPAIGN_FETCH_TABLE_START:
      return setLoading(state, action)
    case CAMPAIGN_FETCH_CHART_START:
      return setLoading(state, action)
    case CAMPAIGN_FETCH_FAIL:
      return fetchStatisticsFail(state, action)
    case CAMPAIGN_DROP_TABLE_DATA:
      return dropStatisticsTable(state, action)
    case TOGGLE_METRIC_HIDDEN:
      return toggleMetricHidden(state, action)
    case SET_CHART_TYPE:
      return setChartType(state, action)
    case SET_CAMPAIGN_LOGIN:
      return setStatisticsCampaignLogin(state, action)
    default:
      return state
  }
}

export default reducer
